import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EfImg from 'elem/ui/ef-img';
import EditorEmarsysEmail from 'lowcode/components/EditorEmarsysEmail';
import { useRouter } from 'next/router';
import { FC } from 'react';
import css from './index.module.scss';

// 通用
const TheCompCommon: FC = () => {
    const { t } = useLang('dp3.teaser.Banner');
    const { locale = 'us' } = useRouter();
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es'].includes(locale);

    const img = {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717211384877/KV-P.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717503433300/KV-M%20(1).jpg',
    };

    const img_eu = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723779319622/kv_pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723779319731/kv_m.jpg',
    };

    return (
        <div id="dp3-teaser-A" className={`${css.thecomp} dp3-teaser-A dp3-teaser-full`}>
            <div className="kv-img">
                <EfImg {...(IS_EU_SITES ? img_eu : img)} />
            </div>
            <div className="kv-info">
                <p className="kv-sub-title">{t('subTitle')}</p>
                <p className="kv-title">{t('title')}</p>
                <p className="kv-desc">{t('desc')}</p>

                <a className="kv-btn" href="#dp3-teaser-B">
                    {t('btn')}
                </a>
                <p className="kv-tips">{t('tips')}</p>
            </div>
        </div>
    );
};

// 日本
const TheCompCommonJP: FC = () => {
    const { t } = useLang('dp3.teaser.Banner');

    return (
        <div id="dp3-teaser-A" className={`${css.thecomp} dp3-teaser-A dp3-teaser-full`}>
            <div className="kv-img">
                <EfImg
                    // alt={t('title')}
                    pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717211384877/KV-P.jpg"
                    h5="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717503433300/KV-M%20(1).jpg"
                />
            </div>
            <div className="kv-info">
                <p className="kv-sub-title">{t('subTitle')}</p>
                <p className="kv-title">{t('title')}</p>
                <p className="kv-desc">{t('desc')}</p>

                <div className="box-emarsys">
                    <EditorEmarsysEmail
                        contactListId="180562521"
                        fields={[
                            // SMS
                            {
                                id: '9157',
                                type: 'multiple',
                                value: [2],
                                overwrite: true,
                            },
                            {
                                id: '31',
                                type: 'single',
                                value: 1,
                                overwrite: true,
                            },
                            {
                                id: '4431',
                                type: 'single',
                                value: 1,
                                overwrite: true,
                            },
                        ]}
                        tipsObj={{
                            placeholder: t('placeholder'),
                            btnText: t('btn'),
                            successTips: t('successTips'),
                            tipsEmpty: t('errorTips'),
                            tipsTypeError: t('errorTips'),
                        }}
                        callback={(value: string) =>
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'activity_submit',
                                button_name: t('btn'),
                                status: value,
                                tag: 'None',
                            })
                        }
                    />
                </div>
                <p className="kv-tips">{t('tips')}</p>
            </div>
        </div>
    );
};

const TheComp: FC = () => {
    const { locale } = useRouter();
    if (locale === 'jp') {
        return <TheCompCommonJP></TheCompCommonJP>;
    }
    return <TheCompCommon></TheCompCommon>;
};

export default TheComp;
